import './App.css';

function App() {
	return (
		<div className="App">
			<header className="App-header">
				<h2 className="text-2xl text-indigo-600 p-20">Hallo Welt</h2>
			</header>
		</div>
	);
}

export default App;
